import React from 'react';
import type { FC } from 'react';
import process from 'node:process';
import { Text } from '@wix/cli-ui-kit';

export const LinkClickTip: FC = () => (
  <Text skin="secondary">
    {`Tip: click a link to open it (some terminals require ${process.platform === 'darwin' ? '⌘' : 'Ctrl'}+click).`}
  </Text>
);
